import React from "react";
import styles from "./Table.module.css";

export const Table = props => (
  <table {...props} className={[styles.Table, props.className].join(" ")} />
);
